import React from "react";
import AdjacentZipsTable from "./AdjacentZipsTable";
import DemandVelocity from "./DemandVelocity";
import RichText from "./RichText";
import LegalStrip from "./LegalStrip";

const renderTileValue = (display) => {
  if (typeof display !== "string") return display;
  return display.split(/(\$|K|M|%)/g).map((token, idx) => {
    if (token === "$" || token === "K" || token === "M" || token === "%") {
      return <span key={idx} className="abr-unit">{token}</span>;
    }
    return <React.Fragment key={idx}>{token}</React.Fragment>;
  });
};

const ZipOverview = ({ zipOverview, property, agent }) => {
  if (!zipOverview) return null;
  return (
    <section id="overview" className="abr-section" aria-labelledby="abr-overview-title">
      <div className="abr-eyebrow">{property.zip} Market Overview</div>
      <h2 className="abr-h1" id="abr-overview-title">
        {zipOverview.title}
      </h2>
      <p className="abr-lede">
        How the wider engaged buyer pool in <span className="abr-accent">{property.zip}</span> compares to your matches
        - useful for a read on neighborhood momentum and where your matches sit inside it.
      </p>

      {zipOverview.tiles && zipOverview.tiles.length ? (
        <div className="abr-overview-tiles">
          {zipOverview.tiles.map((tile, idx) => {
            const valueCls = `abr-tile-value${tile.accent ? " is-accent" : ""}${tile.wordy ? " is-wordy" : ""}`;
            return (
              <div className="abr-card abr-tile" key={idx}>
                <div className="abr-mini-eyebrow">{tile.eyebrow}</div>
                <div className={valueCls} style={tile.accent && tile.wordy ? { color: "var(--abr-accent)" } : undefined}>
                  {renderTileValue(tile.valueDisplay)}
                </div>
                <div className="abr-tile-sub">{tile.sub}</div>
              </div>
            );
          })}
        </div>
      ) : null}

      <AdjacentZipsTable comparison={zipOverview.comparison} />

      <DemandVelocity velocity={zipOverview.velocity} />

      <div className="abr-bottom-line">
        <span className="abr-bottom-line-label">Bottom line</span>
        <RichText as="span" className="abr-bottom-line-text" text={zipOverview.bottomLine} />
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default ZipOverview;
